import { brandFont } from '@/config';

export default {

    brandFont() {
        return brandFont;
    },

    googleFonts() {
        return [
            'Inter',
            'Lato',
            'Merriweather',
            'Montserrat',
            'Noto Sans',
            'Nunito Sans',
            'Open Sans',
            'Poppins',
            'PT Sans',
            'Raleway',
            'Roboto',
            'Source Sans Pro',
            'Ubuntu',
            'Work Sans',
        ];
    },

    systemFonts() {
        return [
            'Arial',
            'Book Antiqua',
            'Calibri',
            'Courier New',
            'Georgia',
            'Garamond',
            'Geneva',
            'Helvetica',
            'Helvetica Neue',
            'Lucida Grande',
            'Palatino',
            'Times New Roman',
            'Tahoma',
            'Trebuchet MS',
            'Verdana',
        ];
    },

    sansSerifFonts() {
        return [
            'Arial',
            'Calibri',
            'Geneva',
            'Helvetica',
            'Helvetica Neue',
            'Lucida Grande',
            'Tahoma',
            'Trebuchet MS',
            'Verdana',
        ];
    },

    serifFonts() {
        return [
            'Book Antiqua',
            'Courier New',
            'Georgia',
            'Garamond',
            'Palatino',
            'Times New Roman',
        ];
    },

    fontStack(font = brandFont) {
        const normalized_font = font.trim();
        if (this.serifFonts().some(f => f.toLowerCase() === normalized_font.toLowerCase())) {
            return `'${normalized_font}', Times, serif`;
        }
        return `'${normalized_font}', Arial, sans-serif`;
    },

    loadGoogleFont(font) {
        if (!this.googleFonts().some(f => f.toLowerCase() === font.toLowerCase())) return;

        const font_name = font.trim().replace(/ /g, '+');
        if (document.querySelector(`link[href*="family=${font_name}"]`)) return;

        const link = document.createElement('link');
        link.href = `https://fonts.googleapis.com/css?family=${font_name}:500,600,700&display=swap`;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    },

    applyBrandFont() {
        // Brand face is self-hosted via sass/brand-font.scss (served via CF).
        document.documentElement.style.setProperty('--font', this.fontStack(brandFont));
    },

    setFont(font) {
        if (!font || typeof font !== 'string') return;

        const normalized_font = font.trim();
        if (normalized_font === brandFont) {
            this.applyBrandFont();
            return;
        }

        if (this.sansSerifFonts().some(f => f.toLowerCase() === normalized_font.toLowerCase())) {
            document.documentElement.style.setProperty('--font', this.fontStack(normalized_font));
        } else if (this.serifFonts().some(f => f.toLowerCase() === normalized_font.toLowerCase())) {
            document.documentElement.style.setProperty('--font', this.fontStack(normalized_font));
        } else {
            this.loadGoogleFont(normalized_font);
            document.documentElement.style.setProperty('--font', this.fontStack(normalized_font));
        }
    },

}
